module.exports = __webpack_public_path__ + "img/etsy.da633b27.png";